module.exports = __webpack_public_path__ + "static/media/ticket-logo-banesco.d6f951a8.svg";